import React, { Fragment, useEffect } from "react";
import Header from "../../Header/Header";
import PageTitle from "../../pagetitle/PageTitle";
import Footer from "../../footer/Footer";
import Scrollbar from "../../scrollbar/scrollbar";
import SaaS from "./SaaS";




const SaaSsinglepage: React.FC = () => {
    useEffect(() => {
        document.title = "SaaS | Brain Machine AI";
      }, []);
    return (
        <Fragment>
            <div className='about-page inner-page'>
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                    <PageTitle pageTitle="SaaS" pagesub="SaaS" />
                      <SaaS></SaaS>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default SaaSsinglepage;
